module.exports = __webpack_public_path__ + "static/media/Avatars_Male-23.243ae643.png";